import styles from "../../assets/styles/profileview.module.scss";
import React from "react";
import ButtonPrimaryComponent from "./buttonPrimaryComponents";
import Loader from "./loader";

export default function ProfileView({
  profile,
  button,
  loading,
  parentClass,
  ...props
}) {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHolder}>
        <div className={styles.cardOutline}>
          {loading ? (
            <Loader />
          ) : (
            <React.Fragment>
              <div className={styles.cardDetails}>
                <div className={styles.cardLeftSec}>
                  <img
                    className={styles.imgProfileView}
                    src={
                      profile?.imgUrl
                        ? profile?.imgUrl
                        : profile?.gender?.value == "female"
                        ? require("../../assets/images/no-img-female-user.jpg")
                        : require("../../assets/images/no-picture.jpg")
                    }
                    alt=""
                  />
                </div>
                <div className={styles.cardRightSec}>
                  <div className={styles.cardUserActions}>
                    <span className={styles.cardUserName}>
                      {profile?.name}
                    </span>
                    <div
                      className={`${styles.cardActions} md:${parentClass}`}
                    >
                      {button?.map((item) => (
                        <ButtonPrimaryComponent
                          className={item?.class}
                          icon={item?.icon}
                          type={item?.type}
                          label={item?.label}
                          disabled={item?.disabled || loading}
                          onClick={item?.onClick}
                        />
                      ))}
                    </div>
                  </div>
                  <div className={styles.cardLineDivider}></div>
                  <div className={styles.cardInfoContainer}>
                    {profile &&
                      Object?.keys(profile)?.map((item, ind) => {
                        if (item === "name" || item === "imgUrl") return <></>;
                        return (
                          <>
                            {ind !== 0 && (
                              <div className={styles.cardLineDividerY} />
                            )}
                            <div className={styles.cardInfo}>
                              <span className={styles.cardHeading}>
                                {profile[item]?.name === "dob"
                                  ? "DOB"
                                  : profile[item]?.name}
                              </span>
                              {profile[item]?.value ? (
                                <span className={styles.cardTitle}>
                                  {profile[item]?.value}
                                </span>
                              ) : (
                                <span
                                  className={`${styles.cardTitle} text-center`}
                                >
                                  -
                                </span>
                              )}
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
}
